import CaseFirstViewItem from './CaseFirstViewItem'

export default CaseFirstViewItem
